import { InjectionToken, Provider } from '@angular/core';

export const GANDALF_HOST = 'http://localhost:8000';
export const GANDALF_SEND_MESSAGE_HOST = 'http://localhost:8001';
export const HELMSDEEP_HOST = 'http://localhost:3001';
export const FRODO_API_HOST = 'http://localhost:4001';
export const CLOUD_HOST = 'http://apex-device.apexpickup.com';
export const FRODO_API_WS_PATH = '';
export const HEALTH_CHECK_BEAT = 5000;
export const LOADS_HARD_RELOAD_THRESHOLD = 10;
export const HEALTH_CHECK_TIMEOUT = 600000;
export const FRODO_DEVICE_SN = 'CHANGEIFNEEDED';
export const DEVICE_ID = 'device-356ab9ed-05d5-4f3e-a004-948e5969dee9';
export const MAX_USE_ADD_COMPARTMENT = '3';
export const SELECTABLE_LANGUAGES = ''; //en,es commas separated
export const MAX_RETRY_CODE_GENERATION = '3';
export const ACTIVATION_PHONE_NUMBER = '800-229-7912';
export const SUPPORT_TOOL_URL = 'SUPPORT_TOOL_URL';
export const PICKUPS_HARD_RELOAD_THRESHOLD = '25';
export const SHOW_NETWORK_PANEL = 'false';
export const UMP_HOST = '';
export const UMP_POLL_INTERVAL_MS = 5000;
export const UMP_REQUEST_TIMEOUT_MS = 4000;

/**
 * Where this Frodo instance is running.
 *   'device' (default): single device running frodo locally. Uses per-node
 *     routing; device-mode UI is fully accessible.
 *   'cloud': cloud-employee deployment running against the gateway. Routes
 *     via /gateway/<service>; device-mode routes are restricted to
 *     /remote-pickup.
 *   'remote-pickup': cloud-pickup-only deployment running against the gateway.
 *     Only /remote-pickup is reachable; all other routes redirect there.
 * Override at deploy time via the RUN_MODE env var (injected by
 * change-host-compiled.js).
 */
export const RUN_MODE: 'device' | 'cloud' | 'remote-pickup' = 'device';

export type RunMode = 'device' | 'cloud' | 'remote-pickup';

/**
 * InjectionToken for RUN_MODE so services and guards can read the value via DI.
 * Tests override with TestBed.overrideProvider(RUN_MODE_TOKEN, useValue: 'cloud').
 * Default is wired up by runModeProvider in AppModule.
 */
export const RUN_MODE_TOKEN = new InjectionToken<RunMode>('RUN_MODE');

export const runModeProvider: Provider = {
  provide: RUN_MODE_TOKEN,
  useValue: RUN_MODE,
};
